import { nanoid } from 'nanoid';
import { get as getStore, set as setStore } from '@utils/store';

export const getDeviceId = () => {
  let deviceId = getStore('DeviceId');
  if (deviceId) {
    return deviceId;
  }
  deviceId = nanoid();
  setStore('DeviceId', deviceId);
};
